import { Section } from "@/components/Section";

const STEPS = [
  { t: "You send the details", d: "Use the form, email, phone or WhatsApp — a few lines about your site and goal is enough." },
  { t: "I reply personally", d: "Within one business day, with an honest take on whether I can help. No sales team, no autoresponder." },
  { t: "Short scoping call", d: "We look at your site together and agree what matters most. Free, no obligation." },
  { t: "Written proposal", d: "A clear scope, price and timeline in writing — you decide with no pressure." },
];

export function NextSteps() {
  return (
    <Section eyebrow="What happens next" title="What happens after you contact me.">
      <ol className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {STEPS.map((s, i) => (
          <li key={s.t} className="rounded-2xl border border-border bg-card p-6">
            <span className="font-display text-3xl text-primary">{i + 1}</span>
            <h3 className="mt-3 font-display text-lg">{s.t}</h3>
            <p className="mt-2 text-sm text-muted-foreground">{s.d}</p>
          </li>
        ))}
      </ol>
    </Section>
  );
}
